import * as z from 'zod';

export const EventItemSchema = z.object({
  id: z.string(),
  checkoutItemId: z.string(),
  checkoutId: z.string(),
  eventId: z.string(),
  eventPricePointId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  consentFormParticipantDateOfBirth: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParticipantPronouns: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParticipantAddress: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerFirstName: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerSurname: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerAddress: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerRelationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerContactNumber: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Name: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Relationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Phone: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Name: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Relationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Phone: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormImportantMedicalInformation: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormMedicationDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormInjuriesDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormDietaryRequirementsDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormDisabilityDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormCodeOfConductAccepted: z.boolean().nullish(),
  codeOfConductConsentedAt: z.coerce.date().nullish(),
  photoConsent: z.boolean().nullish(),
  photoConsentedAt: z.coerce.date().nullish(),
  marketingConsent: z.boolean().nullish(),
  marketingConsentedAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string().nullish(),
  dataProcessingConsent: z.boolean().nullish(),
  dataProcessingConsentedAt: z.coerce.date().nullish(),
  emergencyTreatmentConsent: z.boolean().nullish(),
  emergencyTreatmentConsentedAt: z.coerce.date().nullish(),
});

export type EventItemType = z.infer<typeof EventItemSchema>;
